import React, { useEffect, useState } from "react";

import "./style/prisma-preview.scoped.scss";
import _ from "lodash";

const PrismaPreview = ({ preview }) => {
    const [sources, setSources] = useState(preview.sources);

    const updateSourcesRef = () => {
        if (!preview) {
            return;
        }
        if (preview.toggleOptions.showOtherSources) {
            setSources(preview.sources);
        } else {
            const merged = preview.sources.concat(preview.alternativeSources);
            const grouped = _.groupBy(merged, "_id");
            const result = _.map(grouped, (group, id) => ({
                _id: id,
                count: _.sumBy(group, "count"),
            }));

            setSources(result);
        }
    };

    useEffect(() => {
        updateSourcesRef();
    }, []);

    useEffect(() => {
        if (!preview) {
            return;
        }
    }, [preview]);

    useEffect(() => {
        updateSourcesRef();
    }, [preview.toggleOptions.showOtherSources]);

    const renderWithLineBreaks = (text) => {
        if (!text) {
            return null;
        }

        return text
            .trim()
            .split(/\r\n|\r|\n/) // deal with new lines
            .map((line, index, arr) => (
                <React.Fragment key={index}>
                    {line}
                    {index < arr.length - 1 && <br />}
                </React.Fragment>
            ));
    };

    return (
        <div className="prisma">
            <div className="group phase-1">
                <div className="group-name">{preview.phases[0]}</div>
                <div className="group-content">
                    <div className="block-row">
                        <div className="block left">
                            <span className="corner-number">1.</span>
                            {preview.label1 ? (
                                <div className="line-clamp">
                                    {renderWithLineBreaks(preview.label1)}
                                </div>
                            ) : (
                                <>
                                    Records identified through <br />
                                    database searching <br />
                                </>
                            )}
                            (n={preview.systematic})
                            {preview.toggleOptions.showDatabases ? (
                                <ul>
                                    {sources.map((s, i) => (
                                        <li key={i}>
                                            {" "}
                                            {s._id} (n={s.count}){" "}
                                        </li>
                                    ))}
                                </ul>
                            ) : null}
                            {!preview.toggleOptions.includeDuplicatesInL1Exclusions ? (
                                preview.toggleOptions.showDatabases ? (
                                    <div
                                        className="arrow-down"
                                        style={{ height: "74px", left: "48.5%" }}
                                    ></div>
                                ) : (
                                    <div
                                        className="arrow-down"
                                        style={{ height: "74px", left: "48.5%" }}
                                    ></div>
                                )
                            ) : null}
                        </div>

                        {preview.toggleOptions.showOtherSources ? (
                            <div className="block right">
                                <span className="corner-number">2.</span>
                                {preview.label2 ? (
                                    <div className="line-clamp">
                                        {renderWithLineBreaks(preview.label2)}
                                    </div>
                                ) : (
                                    <>
                                        Additional records identified
                                        <br />
                                        through other sources
                                    </>
                                )}
                                (n={preview.nonSystematic})
                                {preview.toggleOptions.showDatabases ? (
                                    <ul>
                                        {preview.alternativeSources.map((s, i) => (
                                            <li key={i}>
                                                {" "}
                                                {s._id} (n={s.count}){" "}
                                            </li>
                                        ))}
                                    </ul>
                                ) : null}
                                {!preview.toggleOptions.includeDuplicatesInL1Exclusions ? (
                                    <div
                                        className="arrow-diagonal-left"
                                        style={{ height: "120px", left: "-45px", bottom: "-34px" }}
                                    ></div>
                                ) : preview.toggleOptions.showDatabases ? (
                                    <div
                                        className="arrow-diagonal-left"
                                        style={{ height: "120px", left: "-45px" }}
                                    ></div>
                                ) : (
                                    <div
                                        className="arrow-diagonal-left"
                                        style={{ height: "120px", left: "-45px", bottom: "-46px" }}
                                    ></div>
                                )}
                            </div>
                        ) : null}
                    </div>

                    {!preview.toggleOptions.includeDuplicatesInL1Exclusions ? (
                        <div className="block-row" style={{ top: "60px", marginBottom: "60px" }}>
                            <div className="block left">
                                <div className="line-clamp">Records After Duplicate Removed</div>
                                (n={preview.screened})
                            </div>
                        </div>
                    ) : null}

                    {preview.toggleOptions.showDatabases ? (
                        <div className="arrow-down" style={{ height: "54px" }}></div>
                    ) : preview.toggleOptions.includeDuplicatesInL1Exclusions ? (
                        <div className="arrow-down" style={{ height: "80px" }}></div>
                    ) : (
                        <div className="arrow-down" style={{ height: "54px" }}></div>
                    )}
                </div>
            </div>

            <div className="group phase-2">
                <div className="group-name">{preview.phases[1]}</div>
                <div className="group-content">
                    <div className="block-row">
                        <div className="block left">
                            <span className="corner-number">3.</span>
                            {preview.label3 ? (
                                <div className="line-clamp">
                                    {renderWithLineBreaks(preview.label3)}
                                </div>
                            ) : (
                                "Records screened"
                            )}
                            (n={preview.screened})
                            <div className="arrow-container">
                                <div className="arrow-right"></div>
                            </div>
                        </div>

                        <div className="block right">
                            <span className="corner-number">4.</span>
                            {preview.label4 ? (
                                <div className="line-clamp">
                                    {" "}
                                    {renderWithLineBreaks(preview.label4)}{" "}
                                </div>
                            ) : (
                                "Records excluded"
                            )}
                            (n={preview.l1ExclusionReasons.stats.excluded})
                            {preview.toggleOptions.showL1ExclusionReason ? (
                                <ul>
                                    {preview.l1ExclusionReasons.list.map((l, i) => (
                                        <li key={i}>
                                            {l.reason} (n={l.count})
                                        </li>
                                    ))}
                                </ul>
                            ) : null}
                        </div>
                    </div>
                    <div
                        className="arrow-down"
                        style={{ height: "calc(100% - 28px)", top: "auto", marginTop: "79px" }}
                    ></div>
                </div>
            </div>

            <div className="group phase-3">
                <div className="group-name">{preview.phases[2]}</div>
                <div className="group-content">
                    <div className="block-row">
                        <div className="block left">
                            <span className="corner-number">5.</span>
                            {preview.label5 ? (
                                <div className="line-clamp">
                                    {" "}
                                    {renderWithLineBreaks(preview.label5)}{" "}
                                </div>
                            ) : (
                                <>
                                    Full-text articles assessed
                                    <br />
                                    for eligibility
                                </>
                            )}
                            (n={preview.reviewed}) <br />
                            <div className="arrow-container">
                                <div className="arrow-right"></div>
                            </div>
                        </div>

                        <div className="block right">
                            <span className="corner-number">6.</span>
                            {preview.label6 ? (
                                <div className="line-clamp">
                                    {" "}
                                    {renderWithLineBreaks(preview.label6)}{" "}
                                </div>
                            ) : (
                                "Full-text articles excluded"
                            )}
                            (n={preview.l2Excluded})
                            {preview.toggleOptions.showL2ExclusionReason ? (
                                <ul>
                                    {preview.reasons.map((r, i) => (
                                        <li key={i}>
                                            {r.reason} (n={r.count})
                                        </li>
                                    ))}
                                </ul>
                            ) : null}
                        </div>
                    </div>
                    <div className="arrow-down last-arrow"></div>
                </div>
            </div>

            <div className="group phase-4">
                <div className="group-name">{preview.phases[3]}</div>
                <div className="group-content">
                    <div className="block-row">
                        <div className="block left">
                            <span className="corner-number">7.</span>
                            {preview.label7 ? (
                                <div className="line-clamp">
                                    {" "}
                                    {renderWithLineBreaks(preview.label7)}{" "}
                                </div>
                            ) : (
                                "Full-text articles included"
                            )}
                            (n={preview.included})
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrismaPreview;
